
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trails",
      function () {
        return require("private-next-pages/trails/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trails"])
      });
    }
  